import ExpandableText, { ExpandableText as ExpandableTextComponent } from './ExpandableText'
export { ExpandableTextComponent as ExpandableText }
export default ExpandableText
